// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"10":"GamesRevival","121":"react-zoom-pan-pinch","237":"Daily","397":"Blog","745":"Care","830":"Cometogether"}[chunkId] + ".chunk." + {"10":"4cc7fbcc5dcaf232ce62","121":"44a12ec99f1e1f55262f","237":"838a36b56d8cb4315752","397":"4c65a76403de26aaf794","745":"01fdbdc8dc3dffeee062","830":"0ccae11cb76a61cbc326"}[chunkId] + ".js";
};